export default "__VITE_ASSET__BoCWM_W8__"